module.exports = __webpack_public_path__ + "img/Genuss-Cafe-Mozart-Stueberl-HV.9cf5cdb7.jpg";